import { Component, OnInit, Injector } from '@angular/core';
import { RouteValidationService } from "../../../../shared/route-validation.service";
import { Router } from "@angular/router";
import { MaintenanceService } from "./maintenance.service";
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  // styleUrls: ['./maintenance.component.scss']
  host: { 'class': 'router-outlet' },

})
export class MaintenanceComponent implements OnInit {
  maintenanceService: MaintenanceService;
  selected: string = 'default';
  router: Router;
  data: any[];
  editForm: FormGroup;
  
  constructor(
    public routerValidationService: RouteValidationService,
    private readonly injector: Injector
  ) {
    this.router = this.injector.get(Router);
    this.maintenanceService = injector.get(MaintenanceService);
  }

  ngOnInit() {
    this.routerValidationService.selected$
      .subscribe(s => this.selected = s);
    this.routerValidationService.get();
    this.data = this.maintenanceService.getDropDown();
    this.maintenanceService.getCurrentPageValue();
    this.editForm = this.maintenanceService.editForm;
  }
}